import type { Theme } from '../theme';

export const dark: Theme = {
  colors: {
    brand: '#6f34b8',
    brandHover: '#ac69ff',
    brandText: '#ffffff',

    backgroundPrimary: '#070014',
    backgroundSecondary: '#000000',

    textPrimary: '#ffffff',
    textSecondary: '#737380',
    textHover: '#cccccc',
    textHighlight: '#6f34b8',

    border: '#0c0221',
  },
};
